import React from "react";

import {
  Desc,
  Icon,
  Number,
  ResultItem,
  ResultList,
} from "./styles"

type TResultItemType = {
  number?: string;
  icon?: string;
  desc: string;
};

type TResultSection = {
  data: TResultItemType[];
};

export const ResultSection: React.FC<TResultSection> = ({ data }) => {
  return (
    <ResultList>
      {data.map((item, index) => (
        <ResultItem key={index}>
          {item.icon ? (
            <Icon src={item.icon} />
          ) : (
            <Number>{item.number}</Number>
          )}
          <Desc>{item.desc}</Desc>
        </ResultItem>
      ))}
    </ResultList>
  )
}
